"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getContentfulPixelsForApp;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _contentful = require("contentful");

var CONTENTFUL_ENTRIES_LIMIT = 100; // TODO:
// These secrets are going to be used to fetch pixels from public websites, so they're
// not quite "secret" for now.
// That being said, we should make them configurable in case we have separate spaces
// and just for best practice

var contentfulClient = (0, _contentful.createClient)({
  // This is the space ID. A space is like a project folder in Contentful terms
  space: 'vko4isvle8g4',
  // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
  accessToken: 'uKvvFkkSd-Sl-zFMd4rTLj8eT1maZENWmuYDovGkt7E'
});

function getContentfulPixelsForApp(_x) {
  return _getContentfulPixelsForApp.apply(this, arguments);
}

function _getContentfulPixelsForApp() {
  _getContentfulPixelsForApp = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(appId) {
    var skip, items, result, pixelConfigs, relevantPixelConfigs, fireNonLivePixelsAnyway, queryParams, stagingPixelsParam, pageUrl;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            skip = 0;
            items = [];

          case 2:
            _context.next = 4;
            return contentfulClient.getEntries({
              // eslint-disable-next-line camelcase
              content_type: 'pixel',
              skip: skip,
              limit: CONTENTFUL_ENTRIES_LIMIT,
              order: 'sys.createdAt'
            });

          case 4:
            result = _context.sent;
            items.push.apply(items, (0, _toConsumableArray2["default"])(result.items));
            skip += CONTENTFUL_ENTRIES_LIMIT;

          case 7:
            if (result.total > items.length) {
              _context.next = 2;
              break;
            }

          case 8:
            // Turn the contentful entries response into an array of pixelConfigs with { id: contentfulId } and the rest of the fields
            pixelConfigs = items && items.map(function () {
              var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return Object.assign({}, {
                id: item.sys.id
              }, item.fields);
            }); // Get pixels that are global or assigned specifically to this appId

            relevantPixelConfigs = pixelConfigs.filter(function (item) {
              return item && (item.global || (item.appIds || []).includes(appId));
            }); // Note that using document here assumes browser-side. If this function is used in any other context, this should become a function argument

            if (typeof document !== 'undefined') {
              queryParams = new URL(document && document.location).searchParams;
              stagingPixelsParam = queryParams.get('stagingPixels');
              fireNonLivePixelsAnyway = stagingPixelsParam === 'true';
            } // Filter pixels so only "live" ones fire - unless we get the queryParam ?stagingPixels=true


            relevantPixelConfigs = relevantPixelConfigs.filter(function (item) {
              return fireNonLivePixelsAnyway || item.live === true;
            });
            pageUrl = window.location.href; // Enable pixel tracking for urls that contain these strings

            relevantPixelConfigs = relevantPixelConfigs.filter(function (item) {
              if (item) {
                if (item.urlIncludeStrings && item.urlIncludeStrings.length) {
                  return item.urlIncludeStrings.every(function (str) {
                    return pageUrl.includes(str);
                  });
                }

                return true;
              }

              return false;
            }); // Disable pixel tracking for urls that contain these strings

            relevantPixelConfigs = relevantPixelConfigs.filter(function (item) {
              if (item) {
                if (item.urlExcludeStrings && item.urlExcludeStrings.length) {
                  return item.urlExcludeStrings.every(function (str) {
                    return !pageUrl.includes(str);
                  });
                }

                return true;
              }

              return false;
            });
            return _context.abrupt("return", relevantPixelConfigs);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getContentfulPixelsForApp.apply(this, arguments);
}